import { productsAndServicesApi } from 'api';
import { ProductServiceDetailsResponse } from 'pco-product-service-internal-consumer';

export const getAccountProductDetails = async (
  accountNumber: string,
  productServiceId: string,
): Promise<ProductServiceDetailsResponse> => {
  return await productsAndServicesApi.getProductService({ accountNumber, productServiceId });
};
